'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSite$002dScope$0024 from "./presto.types$-Site-Scope$.js";
var $p;
/** @constructor */
function $c_Lpresto_SiteTables$$anon$8() {
}
export { $c_Lpresto_SiteTables$$anon$8 as $c_Lpresto_SiteTables$$anon$8 };
$p = $c_Lpresto_SiteTables$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SiteTables$$anon$8;
/** @constructor */
function $h_Lpresto_SiteTables$$anon$8() {
}
export { $h_Lpresto_SiteTables$$anon$8 as $h_Lpresto_SiteTables$$anon$8 };
$h_Lpresto_SiteTables$$anon$8.prototype = $p;
$p.b6 = (function(_$32) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(_$32, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$33) => _$33.qk)), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_math_Ordering$O$1($j_presto$002etypes$0024$002dSite$002dScope$0024.$m_Lpresto_types$SiteScope$().cI4()));
});
var $d_Lpresto_SiteTables$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SiteTables$$anon$8, "presto.SiteTables$$anon$8", ({
  RG: 1,
  G: 1
}));
export { $d_Lpresto_SiteTables$$anon$8 as $d_Lpresto_SiteTables$$anon$8 };
//# sourceMappingURL=presto.-Site-Tables$$anon$8.js.map
